module.exports = __webpack_public_path__ + "img/fiveinarow_notcompleted.dd9caefb.svg";